import { authSlice } from "./auth/authSlice";
import { demandaSlice } from "./demandas/demandasSlice";
import { expedienteSlice } from "./expediente/expedienteSlice";
import { homeSlice } from "./home/homeSlice";
import { promocionSlice } from "./promociones/promocionesSlice";
import { reportesSilce } from "./reportes/reportesSilce";
import { generalesSlice } from "./serviciosGenerales/generalesSlice";
import { uiSlice } from "./ui/uiSlice";
import { visorDocumentosSlice } from "./visorDocumentos/visorDocumentosSlice";
import { juzgadoConExpedienteSlice } from "./juzgadoConExpediente/juzgadoConExpedienteSlice";
import { servicioWhatsappSlice } from "./servicioWhatsapp/servicioWhatsappSlice";
import { amnistiaSlice } from "./amnistia/amnistiaSlice";
import { apiExpedienteElectronico } from "services/expedienteElectronico/expedienteElectronico";
import { libroIndiceSlice } from "./libroIndice/libroIndiceSlice";
import { apiLibroIndice } from "services/indiceServices/indicesServices";
import { apiSolicitudFirma } from "services/solicitudFirmaService/solicitudFirmaService";
import { solicitudFirmaSlice } from "./solicitudFirma/solicitudFirmaSlice";
import { accesoEdificiosSlice } from "./accesoEdificios/accesoEdificiosSlice";
import { periodosInactividadSlice } from "./periodosInactividad/periodosInactividadSlice";
import { encuestaCalidadSlice } from "./encuestas/encuestaCalidadSlice";
import { audioActuacionSlice } from "./audioActuaciones/audioActuacionSlice";
import { reportesArbolSilce } from "./reportes/reportesArbolJudicial";
import { servicioEncuestaSatisfaccion } from "./servicioEncuestaSatisfaccion/servicioEncuestaSatisfaccionSlice";
import { inscripcionCursosSlice } from "./inscripcionCursos/inscripcionCursosSlice";
import { servicioAvisoLibro } from "./servicioAvisoLibro/servicioAvisoLibroSlice";
import { servicioVideoTraductor } from "./servicioVideoTraductor/servicioVideoTraductorSlice";
import { sliceVideoApp } from "./videoApp/videoAppSlice";

export const rootReducer = {
  [apiExpedienteElectronico.reducerPath]: apiExpedienteElectronico.reducer,
  [apiLibroIndice.reducerPath]: apiLibroIndice.reducer,
  [apiSolicitudFirma.reducerPath]: apiSolicitudFirma.reducer,
  accesoEdificios: accesoEdificiosSlice.reducer,
  amnistia: amnistiaSlice.reducer,
  auth: authSlice.reducer,
  demandas: demandaSlice.reducer,
  encuestaCalidad: encuestaCalidadSlice.reducer,
  expediente: expedienteSlice.reducer,
  generales: generalesSlice.reducer,
  home: homeSlice.reducer,
  juzgadosConExpediente: juzgadoConExpedienteSlice.reducer,
  libroIndice: libroIndiceSlice.reducer,
  periodosInactividadSlice: periodosInactividadSlice.reducer,
  promocion: promocionSlice.reducer,
  reportesArbol: reportesArbolSilce.reducer,
  reportes: reportesSilce.reducer,
  servicioWhatsApp: servicioWhatsappSlice.reducer,
  solicitudFirma: solicitudFirmaSlice.reducer,
  ui: uiSlice.reducer,
  visorDocumentos: visorDocumentosSlice.reducer,
  audioActuacionSlice: audioActuacionSlice.reducer,
  servicioEncuestaSatisfaccion: servicioEncuestaSatisfaccion.reducer,
  inscripcionCursosSlice: inscripcionCursosSlice.reducer,
  servicioAvisoLibro: servicioAvisoLibro.reducer,
  servicioVideoTraductor: servicioVideoTraductor.reducer,
  videoApp: sliceVideoApp.reducer,

};


